import { render } from "./TogglePanel.vue?vue&type=template&id=589257a7&scoped=true&ts=true&lang=pug"
import script from "./TogglePanel.vue?vue&type=script&lang=ts"
export * from "./TogglePanel.vue?vue&type=script&lang=ts"

import "./TogglePanel.vue?vue&type=style&index=0&id=589257a7&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589257a7"]])

export default __exports__